import {
  OrgQueryparams,
  PatientQueryparams,
} from "../../../../core/app/slices/patients/patient.types"

export const defaultQuryParams: PatientQueryparams = {
  page_no: 1,
  per_page: 20,
  sort_field: "case_disposition",
  sort_type: "desc",
  action: "filter",
}

export const defaultOrgParams: OrgQueryparams = {
  page: 1,
  page_size: 10,
  sort_type: "desc",
  sort_by: "id",
}

export const QUERY_PARAMS_STORAGE_KEY = "patientListQueryParams"

export const ORDERED_STATUS = {
  DELIVERED: "DELIVERED",
  SHIPPED: "SHIPPED",
}

export const tableData = {
  columnDef: [
    {
      name: "Last Name",
      id: "last_name",
      dataKey: "lastName",
      cell: {
        style: {
          fontWeight: "bold !important",
          maxWidth: 160,
          textOverflow: "ellipsis",
          overflow: "hidden",
        },
      },
      visible: true,
    },
    {
      name: "First Name",
      id: "first_name",
      dataKey: "firstName",
      cell: {
        style: {
          fontWeight: "bold !important",
          maxWidth: 129,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      visible: true,
    },
    {
      name: "Assigned To",
      id: "assigned_to",
      dataKey: "assignedTo",
      visible: true,
      cell: {
        style: {
          fontWeight: "bold !important",
          maxWidth: 247,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
    },
    {
      name: "Status",
      id: "case_disposition",
      sorty_by: "case_disposition",
      dataKey: "status",
      cell: {
        style: {
          fontWeight: "bold !important",
          maxWidth: 260,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      visible: true,
    },
    {
      name: "Status Updated",
      id: "update_date",
      dataKey: "updatedDate",
      cell: {
        style: {
          fontWeight: "bold !important",
          maxWidth: 200,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      visible: true,
    },
    {
      name: "Case #",
      id: "id",
      dataKey: "case",
      cell: {
        style: {
          fontWeight: "bold !important",
          maxWidth: 112,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      visible: true,
    },
  ],
}

export const orgTableData = {
  columnDef: [
    {
      name: "Org Id",
      id: "org_id",
      dataKey: "org_id",
      cell: {
        style: {
          fontWeight: "bold !important",
          maxWidth: 160,
          textOverflow: "ellipsis",
          overflow: "hidden",
        },
      },
      visible: true,
    },
    {
      name: "Name",
      id: "name",
      dataKey: "name",
      cell: {
        style: {
          fontWeight: "bold !important",
          maxWidth: 260,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      visible: true,
    },
    {
      name: "Account Owner",
      id: "account_owner",
      dataKey: "account_owner",
      cell: {
        style: {
          fontWeight: "bold !important",
          maxWidth: 260,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      visible: true,
    },
    {
      name: "Organization Type",
      id: "org_type",
      dataKey: "org_type",
      cell: {
        style: {
          fontWeight: "bold !important",
          maxWidth: 200,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      visible: true,
    },
    {
      name: "Patient List",
      id: "patient_list",
      dataKey: "patient_list",
      cell: {
        style: {
          fontWeight: "bold !important",
          maxWidth: 200,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      visible: true,
    },
  ],
}
